import { useContext } from 'react'
import CommunityProfileEdit from './CommunityProfileEdit'
import CommunityProfileView from './CommunityProfileView'
import { UserContext, UserContextType } from '../../UserContext'

function CommunityProfilePage({}: {}) {
    // If user has a profile, then show the profile with <CommunityProfileView>.
    // If not, then show <CommunityProfileEdit>
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const communityProfile = state.communityProfile

    return <>{communityProfile ? <CommunityProfileView profile={communityProfile} /> : <CommunityProfileEdit />}</>
}

export default CommunityProfilePage
